<template>
  <div>
    <a-card :title="$t('移动端下载')">
      <div style="text-align: center">
        <vue-qr :text="qrURL" :size="200"></vue-qr>

        <div style="width: 100%; color: #777; font-size: 18px; margin-top: 12px">
          {{ $t("请点击PDA浏览器扫描上方二维码下载安装移动端App。") }}
        </div>
        <div style="width: 100%; color: #777; font-size: 18px">
          {{ $t("为确保兼容性，请联系客户经理购买指定型号PDA。") }}
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import VueQr from "vue-qr";

export default {
  components: {
    VueQr,
  },
  computed: {
    qrURL() {
      return `http://${window.location.host}/download/wms_mobile.apk`;
    },
  },
};
</script>

<style scoped></style>
